import React from "react";
import colors from "@streeteasy/design-system/deprecated/colors";
import { bool, oneOf, string } from "prop-types";

import { BathroomsOutline, BathroomsWrapper, IconWrapper } from "./styled";

/**
 * Static BathroomsIcon component
 */

const BathroomsIcon = ({
  desktopPadding,
  isWrapped,
  mobilePadding,
  strokeColor,
  width
}) => (
  <IconWrapper
    aria-hidden
    desktopPadding={desktopPadding}
    mobilePadding={mobilePadding}
  >
    <BathroomsWrapper viewBox="0 0 17 15" width={width}>
      <BathroomsOutline
        fill="none"
        fillRule="evenodd"
        isWrapped={isWrapped}
        strokeColor={strokeColor}
      >
        <path
          d="M3.421 6.54V3.363c0-1.024.748-1.863 1.662-1.863.914 0 1.662.839 1.662 1.863v.188M.5 6.596h16m-14.976.038v4.252c0 .62.453 1.129 1.007 1.129h11.937c.554 0 1.008-.508 1.008-1.13v-4.25M3.455 12.128v1.41m10.056-1.41v1.41"
          strokeLinecap="round"
        />
      </BathroomsOutline>
    </BathroomsWrapper>
  </IconWrapper>
);

BathroomsIcon.propTypes = {
  /** A string with information about desktop padding styles */
  desktopPadding: string,
  /** Indicates if the BathroomsIcon should receive color behavior from a parent */
  isWrapped: bool,
  /** A string with information about padding on mobile devices. Default is null */
  mobilePadding: string,
  /** Give the icon a stroke color (must be a color from the SE color library) */
  strokeColor: oneOf(Object.keys(colors)),
  /** Give the icon width/height (default is 17px) */
  width: string
};

BathroomsIcon.defaultProps = {
  desktopPadding: "0 6px",
  isWrapped: false,
  mobilePadding: "",
  strokeColor: "koalaGrey",
  width: "17px"
};

export default BathroomsIcon;
